module.exports = __webpack_public_path__ + "static/img/rank_72.e126502.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_72.png
// module id = cWq+
// module chunks = 1